import React from "react";

const Fifth = ({ msg, color }) => {
  return (
    <>
      <ul class="list-disc pl-4 md:p-10 space-y-3 text-gray-500 mt-2">
        <li>Kuwa na ofisi za Kituo</li>
        <li>Kuwa na kiwanja/ viwanja vya michezo, chumba cha mazoezi nk</li>
        <li>Kuwa na vifaa vya wachezaji na vifaa vya michezo</li>
        <li>
          Kuwa na Walimu au kuwepo uwezekano wa kupata walimu wa michezo na
          wataalam wengine wa michezo.
        </li>
        <li>Kuwa na huduma ya maliwato inayokidhi mahitaji ya watu wote</li>
        <li>Kuwa na walau darasa moja kwa ajili ya mafunzo ya nadharia</li>
      </ul>
    </>
  );
};

export default Fifth;
